export default __webpack_public_path__ + "static/media/rosgorstrah.573bb4a8.svg";